export default __webpack_public_path__ + "static/media/hardware.c647d7dc.webp";